import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import AllRoutes from "./routes";

function App() {
  return (
    <div className="App">
      <AllRoutes />
    </div>
  );
}

export default App;
